var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResponsibility(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3345 33.0863C33.9254 33.0863 40.8897 26.1221 40.8897 17.5314C40.8897 8.9407 33.9254 1.97656 25.3345 1.97656C16.7436 1.97656 9.7793 8.9407 9.7793 17.5314C9.7793 26.1221 16.7436 33.0863 25.3345 33.0863Z",
    stroke: "#FAFEFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99805 71.9768V64.1994C1.99805 60.074 3.63689 56.1175 6.55405 53.2004C9.47122 50.2833 13.4277 48.6445 17.5532 48.6445H33.1084C37.2339 48.6445 41.1904 50.2833 44.1076 53.2004C47.0248 56.1175 48.6636 60.074 48.6636 64.1994V71.9768",
    stroke: "#FAFEFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5527 2.47656C55.8987 3.33325 58.8644 5.27916 60.9822 8.00752C63.1001 10.7359 64.2496 14.0915 64.2496 17.5453C64.2496 20.9992 63.1001 24.3548 60.9822 27.0831C58.8644 29.8115 55.8987 31.7574 52.5527 32.6141",
    stroke: "#FAFEFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0004 71.9677V64.1903C71.9806 60.7572 70.8256 57.427 68.7154 54.719C66.6051 52.0109 63.6582 50.077 60.334 49.2188",
    stroke: "#FAFEFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsibility);
export default __webpack_public_path__ + "static/media/responsibility.742e41c6d1b1e288ba0ad88def0b1a05.svg";
export { ForwardRef as ReactComponent };